import { useMemo } from 'react';

import { useGetOptionsForCLA } from 'hooks/useGetOptionsForCLA';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';
import { dateFormatter, nestedFieldValueGetter } from 'utils/grid';
import { numberFormatter } from 'components/shared/DataGrid/utils/valueFormatters/numberFormatter';

const useColumnDefinitions = () => {
  const { t } = useTranslation();
  const claOptions = useGetOptionsForCLA();

  return useMemo(() => {
    return generateColumns(t, claOptions);
  }, [t, claOptions]);
};

const generateColumns = (t: TFunction, claOptions: Option[]): GridColDef[] => [
  {
    field: 'claId',
    headerName: t('dutyCalculationValue.sleepDuty.grid.claId'),
    type: 'singleSelect',
    hideable: false,
    flex: 1,
    minWidth: 70,
    valueOptions: claOptions,
    valueFormatter: (value: string | number) =>
      singleSelectValueFormatter(value, claOptions)
  },
  {
    field: 'hourlyWageValue',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue20',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue20'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue19',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue19'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue18',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue18'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue17',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue17'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue16',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue16'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'hourlyWageValue15',
    headerName: t('dutyCalculationValue.sleepDuty.grid.hourlyWageValue15'),
    type: 'number',
    valueFormatter: numberFormatter,
    flex: 1,
    minWidth: 100
  },
  {
    field: 'valid.from',
    headerName: t('validFrom'),
    type: 'date',
    valueGetter: (_, row) => nestedFieldValueGetter('valid.from', row),
    valueFormatter: dateFormatter,
    width: 110
  },
  {
    field: 'valid.to',
    headerName: t('validTo'),
    type: 'date',
    valueGetter: (_, row) => nestedFieldValueGetter('valid.to', row),
    valueFormatter: dateFormatter,
    width: 110
  }
];

export default useColumnDefinitions;
